export default "__VITE_ASSET__5Kyb03qU__"